import * as React from 'react';

function SvgTermsGray(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
      <g transform="translate(0 -1)" fill="none" fillRule="evenodd">
        <rect fill="#F8F8F6" x={6} y={11} width={31} height={27} rx={2} />
        <path
          d="M15.282 18.55H7.279C6.572 18.55 6 19.1 6 19.777c-.004.67.568 1.215 1.28 1.223h8.002c.711-.004 1.287-.553 1.283-1.223 0-.678-.576-1.227-1.283-1.227zm7.43-5.55H7.28C6.572 13 6 13.549 6 14.223c-.004.67.568 1.219 1.28 1.223h15.437c.707 0 1.283-.549 1.283-1.223S23.42 13 22.712 13z"
          fill="#C8C9CB"
          fillRule="nonzero"
        />
        <path
          d="M31.751 5.399h-2.657v-4.18C29.094.547 28.537 0 27.845 0H4.008C1.883 0 .16 1.63.025 3.672.008 3.75 0 3.832 0 3.918v27.164c0 .086.008.171.025.25C.16 33.375 1.883 35 4.008 35h27.743c.696-.004 1.253-.55 1.249-1.219V6.618c0-.672-.557-1.219-1.249-1.219zM4.008 2.442h22.588v2.957H4.008c-.835 0-1.51-.664-1.51-1.477-.009-.812.667-1.476 1.51-1.48zm0 30.12c-.835 0-1.51-.664-1.51-1.48V7.544c.466.187.978.293 1.514.293h26.49v24.725H4.008z"
          fill="#C8C9CB"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgTermsGray;
